import { useLingui } from '@lingui/react/macro';
import { isThisYear, isToday, isTomorrow } from 'date-fns';
import { upperFirst } from 'es-toolkit/string';
import { useCallback } from 'react';

import { useCurrentLocale } from '#features/i18n';
import { formatDate } from '../utils/formatDate';
import { useUserTimeSettings } from './useUserTimeSettings';

export const useFormatDateRelative = () => {
  const currentLocale = useCurrentLocale();
  const { timeZone, timeFormat } = useUserTimeSettings();
  const { t } = useLingui();

  return useCallback(
    (dateInput: string | Date) => {
      let datePattern = 'dd MMM';

      if (!isThisYear(dateInput, { in: timeZone })) {
        datePattern = 'dd MMM yyyy';
      }

      if (isToday(dateInput, { in: timeZone })) {
        datePattern = `'${t`today`}'`;
      }

      if (isTomorrow(dateInput, { in: timeZone })) {
        datePattern = `'${t`tomorrow`}'`;
      }

      return upperFirst(
        formatDate(dateInput, `${datePattern}, HH:mm`, {
          locale: currentLocale,
          timeZone,
          timeFormat,
        })
      );
    },
    // `t` даёт подписи «сегодня» и «завтра», `currentLocale` уходит в саму дату: нужны обе.
    [t, currentLocale, timeZone, timeFormat]
  );
};
